/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddMemberRequest } from '../../models/add-member-request';
import { OrganizationUserDto } from '../../models/organization-user-dto';

export interface OrganizationMembersPost$Json$Params {
      body?: AddMemberRequest
}

export function organizationMembersPost$Json(http: HttpClient, rootUrl: string, params?: OrganizationMembersPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationUserDto>> {
  const rb = new RequestBuilder(rootUrl, organizationMembersPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationUserDto>;
    })
  );
}

organizationMembersPost$Json.PATH = '/organization/members';
